import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";

/**
 * Modal for configuring communication preferences
 */
const CommPrefModal = ({ open, onClose, onSubmit, modalState, onStateChange }) => {
  const { channel, commPreferenceType } = modalState;

  const handleSubmit = () => {
    if (channel.trim() && commPreferenceType.trim()) {
      onSubmit();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Configure Communication Preferences</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Communication Preference Type"
          fullWidth
          variant="outlined"
          value={commPreferenceType}
          onChange={(e) => onStateChange("commPreferenceType", e.target.value)}
          placeholder="marketing"
          helperText="Enter the communication preference type (e.g., marketing, promotional, newsletter)"
        />
        <TextField
          margin="dense"
          label="Channel"
          fullWidth
          variant="outlined"
          value={channel}
          onChange={(e) => onStateChange("channel", e.target.value)}
          placeholder="email"
          helperText="Enter the communication channel (e.g., email, sms, phone)"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CommPrefModal;
